import { createSlice } from "@reduxjs/toolkit"
import {  stateEnum } from "../constants/enum.js"

const { company } = stateEnum

const initialState = {
  compCode: [],
  compName: [],
  compLogo:[],
  startDate: "",
  endDate: "",
  compState: "",
  address:"",
  yearId: "",
  appType: "",
  gstNo:"",
  groupCode: "",
  isMultipleCompany: false,
  isReload: false,
  objCompanies:[],
  objAcYear:[],
  CurrencySetting:"",
  CurrencyFormatBy:"",
  NavigationNewTab:""
}


const companySlice = createSlice({
  name: company,
  initialState,
  reducers: {
    resetCompCode: (state) => {
      state.compCode = []
      state.compName = []
      state.compLogo = []
      state.startDate = ""
      state.endDate = ""
      state.compState = ""
      state.yearId = ""
      state.appType = ""
      state.groupCode = ""
      state.address=""
      state.panNo=""
      state.isMultipleCompany = false
      state.objCompanies=[]
      state.CurrencySetting=""
      state.CurrencyFormatBy=""
      state.gstNo=""
    },
    resetComapanyState: (state) => {
    },
    setAppType: (state, action) => {
      state.appType = action.payload
    },
    setReload: (state, action) => {
      state.isReload = action.payload
    },
    setCompInfo: (state, action) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
      state.compState = action.payload.state
      state.yearId = action.payload.yearId;
      state.groupCode = action.payload.groupCode;
      state.address=action.payload.address
      state.panNo=action.payload.panNo
      state.gstNo=action.payload.gstNo
      state.objCompanies=action.payload.objComp
    },
    setCompCode: (state, action) => {
      if (action.payload.compCode.length > 1)
        state.isMultipleCompany = true;
      else
        state.isMultipleCompany = false;
      state.compCode = action.payload.compCode
      state.compName = action.payload.compName
      state.compLogo = action.payload.compLogo

    },
    setYearId: (state, action) => {
      state.yearId = action.payload
    },
    setAcYearData: (state, action) => {
      state.objAcYear= action.payload
    },
    setCurrencyType:(state,action)=>{
      state.CurrencySetting=action.payload
    },
     setCurrencyFormatBy:(state,action)=>{
      state.CurrencyFormatBy=action.payload
    },
     setNavigationNewTab:(state,action)=>{
      state.NavigationNewTab=action.payload
    }
  },
})

export const { setCompCode,setCurrencyType,setNavigationNewTab,setCurrencyFormatBy, resetCompCode,setCompInfo, setAppType, setReload, setYearId ,setAcYearData} = companySlice.actions
export default companySlice.reducer
